import script from "./shoppingCar.vue?vue&type=script&setup=true&lang=js"
export * from "./shoppingCar.vue?vue&type=script&setup=true&lang=js"

import "./shoppingCar.vue?vue&type=style&index=0&id=4f86a432&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f86a432"]])

export default __exports__